import Heading from './Heading'
export * from './types'
export { Heading }
